import simboloCf from "../assets/cf-simbolo.png";

// A tela de espera do hub.
//
// O símbolo do CF é o PNG oficial do design system, não um "C" redesenhado em
// SVG: o pacote de marca tem uma pendência aberta de exportar o vetor, e
// aproximar a letra à mão daria um logo parecido, que é pior que o logo. O que
// se anima em volta dele é SVG — dois arcos laranja em sentidos opostos, o de
// dentro mais rápido —, e o símbolo só respira.
//
// Por que arco girando e não spinner comum: o símbolo do CF já É um C aberto, um
// arco interrompido. O anel que gira em volta completa o gesto da marca em vez
// de pousar um widget genérico ao lado dela.
//
// `motion-safe:` em tudo que se move: quem pede movimento reduzido no sistema vê
// o símbolo e o texto parados, sem anel girando indefinidamente.
export default function Carregando({ texto = "Carregando…" }: { texto?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-screen flex-col items-center justify-center gap-6 px-4"
    >
      <div className="relative grid size-28 place-items-center">
        <svg viewBox="0 0 100 100" className="absolute inset-0 size-full" aria-hidden="true">
          {/* Arco externo: 1/4 de volta desenhado, gira no sentido do relógio. */}
          <circle
            cx="50"
            cy="50"
            r="46"
            fill="none"
            stroke="var(--color-laranja)"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeDasharray="72 217"
            className="origin-center motion-safe:animate-[cf-orbita_1.4s_linear_infinite]"
          />
          {/* Arco interno: menor, mais lento, sentido contrário — dá profundidade
              sem precisar de terceira volta. */}
          <circle
            cx="50"
            cy="50"
            r="38"
            fill="none"
            stroke="var(--color-azul-medio)"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeDasharray="30 209"
            opacity="0.55"
            className="origin-center motion-safe:animate-[cf-orbita_2.6s_linear_infinite_reverse]"
          />
        </svg>
        <img
          src={simboloCf}
          alt=""
          className="size-12 motion-safe:animate-[cf-respira_2.2s_ease-in-out_infinite]"
        />
      </div>

      <p className="font-display text-sm font-semibold tracking-wide text-cinza motion-safe:animate-[cf-varredura_2.4s_linear_infinite] motion-safe:bg-[linear-gradient(90deg,var(--color-cinza)_35%,var(--color-azul)_50%,var(--color-cinza)_65%)] motion-safe:bg-[length:220%_100%] motion-safe:bg-clip-text motion-safe:text-transparent">
        {texto}
      </p>
    </div>
  );
}
